import { Facebook, Twitter, Linkedin, MessageCircle, Share2 } from "lucide-react";

export function SocialShare({ className = "", label = true }) {
  const url = typeof window !== "undefined" ? window.location.origin : "https://vecpadi.com";
  const text = "Meet VecPadi — Your Vehicle Padi. Your car. Your safety. No wahala.";

  const items = [
    { label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`, hover: "hover:bg-emerald-500" },
    { label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, hover: "hover:bg-blue-600" },
    { label: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, hover: "hover:bg-zinc-900" },
    { label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, hover: "hover:bg-sky-700" },
  ];

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "VecPadi", text, url }); } catch {}
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-share">
      {label && <span className="mr-1 text-xs font-medium text-zinc-400">Share:</span>}
      {items.map((s) => (
        <a
          key={s.label}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`share-${s.label.toLowerCase()}`}
          aria-label={`Share on ${s.label}`}
          className={`grid h-9 w-9 place-items-center rounded-full border border-zinc-200 bg-white text-zinc-500 transition-colors hover:border-transparent hover:text-white ${s.hover}`}
        >
          <s.icon size={16} />
        </a>
      ))}
      <button
        onClick={nativeShare}
        data-testid="share-native"
        aria-label="Share"
        className="grid h-9 w-9 place-items-center rounded-full border border-zinc-200 bg-white text-zinc-500 transition-colors hover:border-transparent hover:bg-emerald-500 hover:text-white sm:hidden"
      >
        <Share2 size={16} />
      </button>
    </div>
  );
}
